
export const RIDE_STATUS = ["CREATED", "STARTED", "FINISHED", "CANCELLED"];
